import ParameterErrors from '../errors/ParameterErrors';
import ParseError from '../errors/ParseError';
import ExportedCubeJson from '../360_react/ExportedCubeJson';
import Scene360 from '../360_react/Scene360';
import Scene360Layer from '../360_react/Scene360Layer';
import Scene360LayerChoice from '../360_react/Scene360LayerChoice';
import SiteJsonOutside360Scene from './SiteJsonOutside360Scene';
import Urls from '../urls/Urls';
const { throwNotProvided, throwNotOfType} = ParameterErrors;
export default class SiteJsonOutside360{
	constructor(props){
		const{scenes, getPlotByNumber, configuration}=props;
		if(scenes===undefined||scenes===null)
			throwNotProvided('scenes');
		this._scenes = scenes;
		this._configuration = configuration;
		this._scene360s = null;
		this.getScene360s = this.getScene360s.bind(this);
		this._getScene360s = this._getScene360s.bind(this);
		 this._getPlotByNumber= getPlotByNumber;
	}
	get scenes(){
		return this._scenes;
	}
	getDefaultScene(siteRelativePath){
		return this.getScene360s(siteRelativePath)[0];
	}
	getScene360s(siteRelativePath){
		if(this._scene360s===undefined||this._scene360s===null){
			this._scene360s = this._getScene360s(siteRelativePath);
		}
		return this._scene360s;
	}
	_getScene360s(siteRelativePath){
		const scene360s = [];
		for(var i=0; i<this._scenes.length; i++){
			try{
				const scene = this._scenes[i];
				scene360s.push(
					new Scene360({
						levels:scene.exportedCubeJson.levels,
						uniqueId:scene.uniqueId,
						urlPrefix:Urls.getOutside360(this._configuration),
						hotspots:scene.hotspots,
						cameraEulerAngles:scene.cameraEulerAngles,
						layers:[
							new Scene360Layer({
								slug:scene.exportedCubeJson.directoryRelativePath,
								choices:[new Scene360LayerChoice({slug:null})],
								getPlotByNumber: this._getPlotByNumber
							})
						]
					})
				);
			}
			catch(e){
				throw new Error(`Parsing scene at index ${i}: ${e?.stack}`);
			}
		}
		return scene360s;
	}
	static fromJSON(jObjectOutside360, getPlotByNumber, configuration){
		const scenes = jObjectOutside360.scenes.map(scene=>SiteJsonOutside360Scene.fromJSON(scene, getPlotByNumber, configuration));
		return new SiteJsonOutside360({scenes:scenes, configuration});
	}
}